module.exports = new Promise((resolve, reject) => {
    const ENV_URLS = {
        production: 'https://assets.nuorder.com/federated/payments/remoteEntry.js',
        staging: 'https://assets.staging.nuorder.com/federated/payments/remoteEntry.js',
        staging02: 'https://assets.stg02.nuorder.com/federated/payments/remoteEntry.js',
        stg02: 'https://assets.stg02.nuorder.com/federated/payments/remoteEntry.js',
        'pre-prd': 'https://assets.pre-prd.nuorder.com/federated/payments/remoteEntry.js',
        sandbox1: 'https://assets.sandbox1.nuorder.com/federated/payments/remoteEntry.js'
    };
    const federatedPath = ENV_URLS[window.nuConfig?.ENVIRONMENT] || ENV_URLS.staging;
    
    const script = document.createElement('script');
    script.src = federatedPath;
    script.onload = () => {
        const proxy = {
            get: (request) => window.Payments.get(request),
            init: (arg) => {
                try {
                    return window.Payments.init(arg);
                } catch(e) {
                    console.error('Payments remote container already initialized');
                }
            }
        };
        resolve(proxy);
    };
    script.onerror = (error) => {
        console.error('Failed to load Payments remote from:', federatedPath, error);
        reject(new Error('Failed to load Payments remote module'));
    };
    document.head.appendChild(script);
});